module.exports = __webpack_public_path__ + "static/media/twitter.dcf5fac7.svg";